var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.seoWidgets.length)?_c('l-container',{staticClass:"seo-widgets-links__container"},_vm._l((_vm.seoWidgets),function(widget,key){return _c('oz-seo-widgets-group',{key:key,attrs:{"widget":widget,"titleClass":"text-regular","fixed":12}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }